// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1XyYF","content":"RecentSearches_content__2tLXm"};